<template>
  <div class="card-document-page">
    <div>
      <div
        class="card-document-signature"
        :class="{ 'is-signed': isSigned }"
        v-if="signature"
      >
        <signature-banner
          :signature="signature"
          :discarding="discardingSignature"
          @retry="openSignModal"
          @discard="discardSignature"
        >
          <st-button-report
            v-if="isSigned"
            slot="actions"
            type="pdf"
            button-class="btn-sm btn-primary"
            label="Imprimir impresso assinado"
            :icon="['fal', 'file-signature']"
            :options="null"
            :route="printLink()"
          ></st-button-report>
        </signature-banner>
      </div>
    </div>
    <div>
    <div class="card-document-signed" v-if="isSigned">
      <div class="document-signed-sheet">
        <div class="document-signed-heading">
          <div class="document-signed-heading-icon">
            <fa-icon :icon="['fal', 'file-medical-alt']" />
          </div>
          <div class="document-signed-heading-text">
            <div class="document-signed-title">{{ signedKindName }}</div>
            <div class="document-signed-subtitle">
              Conteúdo assinado digitalmente, disponível apenas para leitura
            </div>
          </div>
          <div class="document-signed-date" v-if="signedDate">
            <fa-icon :icon="['fal', 'calendar-alt']" />
            <span>{{ signedDate | date }}</span>
          </div>
        </div>
        <div class="document-signed-content" v-if="document" v-html="document"></div>
        <div class="document-signed-none" v-else>Impresso sem conteúdo</div>
      </div>
    </div>
    <template v-else>
    <div class="card-document-header">
      <div class="columns">
        <div class="column col-2 col-md-4 col-sm-12 centered"
             :class="{'has-error': $v.date.$error}">
          <dx-input-date class="text-center"
                         v-model="date"
                         :disabled="isSignatureLocked"
                         @change="setDate"
                         @blur="$v.date.$touch()"
          />
        </div>
        <div class="column hide-sm" />
        <div class="column col-auto col-md-auto col-sm-12">
          <div class="input-group" :class="{loading: loadingModel}">
            <select class="form-select" v-model="modelId"
                    :disabled="loadingModel || isSignatureLocked" @change="getModel">
              <option value="">Meus modelos de impressos</option>
              <option v-for="(item, i) in models" :value="item.id" :key="i">
                {{ item.name }}
              </option>
            </select>
            <button class="btn btn-neutral input-group-btn"
                    @click="openEditModel">
              Gerenciar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-document-body">
      <st-editor id="document-editor"
                 :disabled="isSignatureLocked"
                 v-model="document"></st-editor>
    </div>
    </template>
    </div>
    <div>
    <div class="card-document-footer" v-if="!isSigned">
      <div class="d-flex centered">
        <st-button-report
          type="pdf"
          button-class="btn-gray"
          :disabled="pending || isSignatureRunning"
          :route="printLink()"
        ></st-button-report>
        <button
          v-if="isDigitalSignatureEnabled"
          type="button"
          class="btn btn-gray btn-icon btn-icon-left ml-2"
          :disabled="pending || !data.id || !document || isSignatureRunning"
          @click="openSignModal"
        ><fa-icon :icon="['fal', 'signature']" /> Assinar</button>
        <button class="btn btn-icon-left btn-error ml-2"
                :disabled="pending || isSignatureLocked"
                @click="remove">
          <fa-icon :icon="['fal', 'trash']"/>
          Excluir
        </button>
      </div>
    </div>
    </div>
    <document-sign-modal
      v-if="signModal.show"
      :show="signModal.show"
      :kind="signature ? signature.kind : ''"
      @sign="signDocument"
      @close="signModal.show = false"
    />
    <dx-modal title="Salvar modelo" v-model="modal.show" v-if="modal.show"
              id="modal-place" size="sm">
      <div class="columns">
        <div class="column col-12 form-group">
          <label for="name" class="form-label">Nome</label>
          <input type="text" id="name" name="name" ref="name"
                 class="form-input" v-model="modal.form.name"
                 placeholder="Defina um nome do impresso" autocomplete="nope">
        </div>
        <div class="column col-12 form-group">
          <label for="size" class="form-label">Formato para impressão</label>
          <select id="size" name="size" class="form-select"
                  v-model="modal.form.size">
            <option value="A4">A4</option>
            <option value="A5">A5</option>
          </select>
        </div>
      </div>
      <template slot="footer">
        <button class="btn btn-primary mr-1" :class="{loading: modal.saving}"
                :disabled="modal.saving"
                @click="saveModel">Salvar</button>
        <button class="btn" @click="modal.show = false">Sair</button>
      </template>
    </dx-modal>
    <modal-edit
      v-if="editModels.show"
      :show="editModels.show"
      @close="closeEditModel"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';
import Phone from 'src/filters/phone';
import Cpf from 'src/filters/cpf';
import DateOld from 'src/filters/date-old';
import digitalSignatureMixin from '@/mixins/digital-signature';
import SignatureBanner from '@/components/digital-signature/SignatureBanner.vue';
import DocumentSignModal from '@/components/digital-signature/DocumentSignModal.vue';
import { MEDICAL_RECORD_DOCUMENT, documentKinds } from '@/data/digital-signature';
import ModalEdit from '../../../../template/components/document/modals/Main.vue';
import { date } from '../../../../../data/validators';

export default {
  mixins: [digitalSignatureMixin],
  components: {
    ModalEdit,
    SignatureBanner,
    DocumentSignModal,
  },
  props: {
    patient: {
      name: {
        type: String,
      },
      birthDate: {
        type: Date,
      },
      gender: {
        type: String,
      },
      phone: {
        type: String,
      },
      cellphone: {
        type: String,
      },
      identity: {
        type: {
          type: String,
        },
        value: {
          type: String,
        },
      },
      addresses: {
        type: Array,
      },
    },
    medicalRecordId: {
      type: String,
    },
    data: {
      id: {
        type: String,
      },
      data: {
        type: String,
      },
    },
  },
  data() {
    return {
      models: [],
      modelId: '',
      document: '',
      date: moment().format('YYYY-MM-DD'),
      pending: false,
      printing: false,
      loadingModel: false,
      modal: {
        show: false,
        saving: false,
        form: this.blankModelForm(),
      },
      editModels: {
        show: false,
      },
      signModal: {
        show: false,
      },
      debounceTimeout: null,
    };
  },
  created() {
    this.signature = this.data.digitalSignature || null;
  },
  watch: {
    document: {
      handler() {
        if (this.isSignatureLocked) {
          return;
        }
        this.pending = true;
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
          this.debounceTimeout = null;
          if (this.isSignatureLocked) {
            this.pending = false;
            return;
          }
          this.save();
        }, 1000);
      },
      deep: true,
    },
  },
  mounted() {
    this.document = this.data.data;
    this.loadModels();
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
    signedKindName() {
      const kind = this.signature ? this.signature.kind : null;
      return (kind && documentKinds[kind]) || 'Impresso';
    },
    signedDate() {
      return this.date && this.date.length === 10 && moment(this.date).isValid()
        ? this.date
        : null;
    },
  },
  validations() {
    return {
      date: { date },
    };
  },
  methods: {
    isOwnDigitalSignature(data) {
      return data.type === MEDICAL_RECORD_DOCUMENT
        && !!this.data.id
        && data.itemId === this.data.id;
    },
    openSignModal() {
      if (this.pending || !this.data.id) {
        return;
      }
      this.signModal.show = true;
    },
    async signDocument({ kind, pageSize }) {
      if (this.debounceTimeout) {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = null;
        if (!await this.save()) {
          return;
        }
      }

      if (!this.data.id) {
        return;
      }

      this.requestDigitalSignature(this.medicalRecordId, {
        type: MEDICAL_RECORD_DOCUMENT,
        itemId: this.data.id,
        kind,
        pageSize,
        date: this.date || null,
      }, () => {
        this.signModal.show = false;
      });
    },
    discardSignature() {
      this.discardDigitalSignature('impresso');
    },
    setDate() {
      if (this.date && (this.date.length < 10 || !moment(this.date).isValid())) {
        this.date = '';
      }
    },
    loadModels() {
      const params = {
        active: true,
        limit: 0,
        professionalId: this.user.id,
      };
      this.$httpX.get('/document-templates', { params })
        .then(({ data }) => {
          this.models = data.items;
        })
        .catch(this.$toast.error);
    },
    getModel() {
      if (!this.modelId) {
        return;
      }
      this.loadingModel = true;
      this.$httpX.get(`/document-templates/${this.modelId}`)
        .then(({ data }) => {
          if (data && data.data) {
            const address = this.patient.addresses
            && this.patient.addresses.length > 0
              ? this.patient.addresses[0] : null;

            this.document = data.data
              .replace(/\[date]/g, moment().format('DD/MM/YYYY'))
              .replace(/\[hour]/g, moment().format('HH:mm'))
              .replace(/\[cid]/g, '')
              .replace(/\[patient_name]/g, this.patient.name)
              .replace(/\[patient_gender]/g,
                this.patient.gender === 'male'
                  ? 'Masculino'
                  : 'feminino')
              .replace(/\[patient_birth_date]/g, moment(this.patient.birthDate)
                .format('DD/MM/YYYY'))
              .replace(/\[patient_age]/g,
                DateOld(this.patient.birthDate, true))
              .replace(/\[patient_cpf]/g,
                this.patient.identity && this.patient.identity.value
                  ? Cpf(this.patient.identity.value)
                  : null)
              .replace(/\[patient_phone]/g, Phone(this.patient.cellphone))
              .replace(/\[patient_address]/g, this.formatAddress(address));
            this.modelId = '';
          }
        })
        .catch(this.$toast.error)
        .then(() => {
          this.loadingModel = false;
        });
    },
    openEditModel() {
      this.editModels.show = true;
    },
    closeEditModel() {
      this.loadModels();
      this.editModels.show = false;
    },
    formatAddress(item) {
      if (item) {
        return `${
          item.addressLine1
        } ${
          item.addressLine2
        }, ${
          item.neighborhood
        } - ${
          item.city
        }-${
          item.state
        }`;
      }
      return '';
    },
    saveModel() {
      this.modal.saving = true;
      const data = {
        id: this.modelId,
        professionals: [
          { id: this.user.id, name: this.user.name },
        ],
        active: true,
        data: this.document,
      };

      if (this.modal.form.name) {
        data.name = this.modal.form.name;
      }

      if (this.modal.form.size) {
        data.size = this.modal.form.size;
      }

      const request = !data.id
        ? this.$httpX.post('/document-templates', data)
        : this.$httpX.put(`/document-templates/${data.id}`, data);

      // eslint-disable-next-line consistent-return
      return request
        .then(({ data: result }) => {
          const found = this.models.find(model => model.id === result.id);
          if (!found) {
            this.models.push({
              id: result.id,
              name: result.name,
            });
          } else {
            found.name = result.name;
            found.size = result.size;
          }
          this.modelId = result.id;
          this.$toast.show('Salvo com sucesso!');
          this.modal.show = false;
        })
        .catch(this.$toast.error)
        .then(() => {
          this.modal.saving = false;
        });
    },
    save() {
      const data = {
        id: this.data.id,
        data: this.document,
      };
      const request = !this.data.id
        ? this.$httpX
          .post(`/medical-records/${this.medicalRecordId}/documents`, data)
        : this.$httpX
          .put(`/medical-records/${this.medicalRecordId}/documents/${this.data.id}`, data);

      return request
        .then(({ data: result }) => {
          this.data.id = result.id;
          return true;
        })
        .catch(() => {
          this.$toast.error('Ocorreu um erro ao salvar este registro. Tente novamente!');
          return false;
        })
        .finally(() => {
          this.pending = false;
        });
    },
    remove() {
      this.$dialog.show('', {
        html:
          '<div class="text-center">'
          + '<h5 class="text-center">Atenção!</h5>'
          + '<div>Deseja realmente excluir este impresso?</div>'
          + '</div>',
        buttons: [
          {
            label: 'Não',
            classes: '',
          }, {
            label: 'Sim',
            classes: 'btn-primary btn-error ml-2',
            click: (close) => {
              this.$emit('remove');
              close();
            },
          },
        ],
      });
    },
    printLink() {
      let url = `/medical-records/${this.medicalRecordId}/documents/${this.data.id}/print`;

      if (this.date) {
        url += `?date=${this.date}`;
      }

      return url;
    },
    blankModelForm() {
      return {
        name: '',
        size: 'A4',
      };
    },
  },
};
</script>

<style lang="scss">
  @import "../../../../../assets/scss/variables";
  .card-document-page {
    background-color: lighten($gray-color, 24%);
    border: $border-width solid $border-color;
    border-radius: $border-radius;
    margin-bottom: $layout-spacing-lg;
    .card-document-signature {
      padding: $layout-spacing $layout-spacing 0;
      &.is-signed {
        padding: $layout-spacing-lg $layout-spacing-lg 0;
        .digital-signature-banner {
          flex-wrap: wrap;
          margin-bottom: .6rem;
        }
        .banner-content {
          flex: 1 1 12rem;
        }
        .banner-actions {
          flex-wrap: wrap;
          justify-content: flex-end;
          margin-left: auto;
        }
      }
    }
    .card-document-signed {
      padding: 0 $layout-spacing-lg $layout-spacing-lg;
    }
    .document-signed-sheet {
      background-color: $light-color;
      border: $border-width solid $border-color;
      border-radius: $border-radius;
      overflow: hidden;
    }
    .document-signed-heading {
      align-items: center;
      border-bottom: $border-width solid $border-color;
      display: flex;
      flex-wrap: wrap;
      gap: $layout-spacing;
      padding: .6rem $layout-spacing-lg .6rem ($layout-spacing-lg + .2rem - $border-width);
    }
    .document-signed-heading-icon {
      align-items: center;
      background-color: lighten($primary-color, 34%);
      border-radius: 50%;
      color: $primary-color;
      display: flex;
      flex: 0 0 1.8rem;
      font-size: $font-size-lg;
      height: 1.8rem;
      justify-content: center;
    }
    .document-signed-heading-text {
      flex: 1 1 10rem;
      min-width: 0;
    }
    .document-signed-title {
      color: $gray-color-900;
      font-size: $font-size-lg;
      font-weight: 700;
      line-height: 1.25;
    }
    .document-signed-subtitle {
      color: $gray-color-dark;
      font-size: $font-size-sm;
      margin-top: .1rem;
    }
    .document-signed-date {
      align-items: center;
      border: $border-width solid $border-color;
      border-radius: 1rem;
      color: $gray-color-dark;
      display: inline-flex;
      font-size: $font-size-sm;
      font-weight: 600;
      gap: .3rem;
      line-height: 1;
      margin-left: auto;
      padding: .3rem .6rem;
      white-space: nowrap;
    }
    .document-signed-content {
      color: $gray-color-900;
      font-size: $font-size;
      line-height: 1.7;
      margin: 0 auto;
      max-width: 36rem;
      overflow-wrap: anywhere;
      padding: 1.4rem 1.6rem 1.6rem;
      > :first-child {
        margin-top: 0;
      }
      > :last-child {
        margin-bottom: 0;
      }
      p {
        margin: 0 0 .6rem;
      }
      h1, h2, h3, h4, h5, h6 {
        color: $gray-color-900;
        font-weight: 700;
        line-height: 1.3;
        margin: 1rem 0 .5rem;
      }
      h1 {
        font-size: $font-size-lg * 1.25;
      }
      h2 {
        font-size: $font-size-lg * 1.1;
      }
      h3, h4, h5, h6 {
        font-size: $font-size-lg;
      }
      ul, ol {
        margin: 0 0 .6rem 1.2rem;
        li {
          margin-top: .15rem;
        }
      }
      blockquote {
        border-left: .15rem solid $border-color;
        color: $gray-color-dark;
        margin: 0 0 .6rem;
        padding: .1rem 0 .1rem .8rem;
      }
      hr {
        border: 0;
        border-top: $border-width solid $border-color;
        margin: 1rem 0;
      }
      figure.table {
        margin: 0 0 .8rem;
        overflow-x: auto;
      }
      table {
        border-collapse: collapse;
        margin: 0 0 .8rem;
        width: 100%;
        td, th {
          border: $border-width solid $border-color;
          font-size: $font-size-sm;
          padding: .3rem .5rem;
          text-align: left;
          vertical-align: top;
        }
        th {
          background-color: $gray-color-ultra-light;
          font-weight: 600;
        }
      }
      img {
        height: auto;
        max-width: 100%;
      }
    }
    .document-signed-none {
      color: $gray-color-dark;
      font-size: $font-size-sm;
      padding: $layout-spacing-lg;
      text-align: center;
    }
    @media (max-width: $size-sm) {
      .card-document-signature.is-signed {
        padding: $layout-spacing $layout-spacing 0;
      }
      .card-document-signed {
        padding: 0 $layout-spacing $layout-spacing;
      }
      .document-signed-heading-text {
        flex-basis: calc(100% - 2.2rem);
      }
      .document-signed-date {
        margin-left: 2.2rem;
      }
      .document-signed-content {
        padding: 1rem;
      }
    }
    .card-document-header {
      background-color: lighten($gray-color, 15%);
      padding: $layout-spacing;
    }
    .card-document-body {
      padding-top: $layout-spacing-lg;
    }
    .card-document-footer {
      padding: $layout-spacing-lg;
      text-align: center;
      button {
        min-width: 7rem;
      }
    }
    .document-editor-header {
      position: sticky;
      top: 80px;
      background: #FFF;
      padding-top: $layout-spacing;
    }
    .document-editor-body {
      background-color: $light-color;
      .ck.ck-content.ck-editor__editable {
        min-height: 40rem;
        padding: 15px 72px;
      }
    }
  }
</style>
